import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import RequesterApp from './MarsRequestor';
import AppAdmin from './MarsAdmin.js';
import MarsFamilyCompleteApp from './MarsFamilyComplete.js'
import GetDetailMarsComplete from './components/getDetailMarsComplete.js';
import AppReport from './AppReport';
import Login from './components/Login';
import SiteManagement from './components/SiteManagement.jsx/SiteManagement.js';
import SiteDetails from './components/SiteManagement.jsx/SiteDetails.js';
import './App.css';
import Create from './components/create.js';
import GetDetail from './components/getDetail.js';
import GetDetailEmail from './components/getDetailEmail.js';
import GetDetailAdmin from './components/GetDetailAdmin.js';
import Dashboard from './components/Dashboard/DashBoard.js'

// App Report Api's
import EventsReport from './components/Reports.jsx/eventsReport.js';
import TouchesReport from './components/Reports.jsx/touchesReport.js';
import SiteReport from './components/Reports.jsx/siteReport.js';
import AnniversaryContainer from './components/Reports.jsx/AnniversaryContainer.js';
import UserManagement from './components/UserManagement.jsx/UserManagement.js';
import AddUser from './components/UserManagement.jsx/AddUser.js';
import AppSettings from './components/AppSettings.jsx/AppSettings.js';
import GetDetailEventMlt from './components/Eventmlt.jsx/GetDetailsEventMlt.js';
import EventMltComplete from './components/Eventmlt.jsx/EventMltComplete.js';
import EmailConditionsList from "./components/EmailTemplates/EmailConditionsList.jsx";
import EmailDetails from "./components/EmailTemplates/EmailDetails.jsx";
import EmailNewTemplate from "./components/EmailTemplates/EmailNewTemplate.jsx";
import NotificationListPage from './components/Notification/NoticationListPage.jsx';
import { MsalProvider } from "@azure/msal-react";
import PrivateRoute from './authentification/PrivateRoute.js';

// Mantine
import { PillsInput, createTheme, MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';

// Toastify
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { b2cConfig } from './authentification/msalConfig.js';

const theme = createTheme({
  components: {
    PillsInput: PillsInput.extend({
      styles: {
        input: {
          color: 'darkblue',
          fontWeight: '500',
          fontSize: '12px',
          backgroundColor: '#E5E5F5',
          border: 'var(--bs-border-width) solid var(--bs-border-color)',
          borderRadius: 'var(--bs-border-radius)',
          transition: 'border-color .15s ease-in-out, box-shadow .15s ease-in-out'
        }
      }
    })
  }
});

function App({ instance }) {
  const [isLoading, setIsLoading] = useState(false);
  let refCount = 0;

  axios.interceptors.request.use(async (config) => {
    const accounts = instance.getAllAccounts();
    if (!accounts || accounts.length === 0) {
      // No account in cache return to login.        
      window.location.href = '/login';
      return config;
    }

    try {
      const response = await instance.acquireTokenSilent({
        scopes: b2cConfig.scopes,
        account: accounts[0]
      });

      config.headers['Authorization'] = `Bearer ${response.accessToken}`;

      const impersonatedUser = JSON.parse(localStorage.getItem('impersonatedUser')) || null;
      if (impersonatedUser !== null) {
        config.headers['X-Impersonated-User-Id'] = impersonatedUser.id;
      }
    } catch (error) {
      // Unable to acquire token return to login.
      window.location.href = '/login';
    }

    return config;
  });

  axios.interceptors.request.use((config) => {
    refCount++;
    setIsLoading(true);
    return config;
  }, (error) => {
    refCount--;
    if (refCount == 0) {
      setIsLoading(false);
    }
    return Promise.reject(error);
  });

  axios.interceptors.response.use((response) => {
    refCount--;
    if (refCount == 0) {
      setIsLoading(false);
    }
    return response;
  }, (error) => {
    refCount--;
    if (refCount == 0) {
      setIsLoading(false);
    }
    return Promise.reject(error);
  });

  return (
    <MantineProvider theme={theme}>
      <MsalProvider instance={instance}>
        <Router>
          <div>
            <link
              rel="stylesheet"
              href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
              integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
              crossOrigin="anonymous"
            />
            <Routes>
              <Route path="/" element={<Navigate to="/login" />} />
              <Route path="/login" element={<Login />} />

              {/* Protected Routes */}
              <Route element={<PrivateRoute />}>
                <Route path="/create" element={<Create />} />
                <Route path="/getDetailEmail/:eventId" element={<GetDetailEmail />} />
                <Route path="/getDetailEmail/guest/:eventId" element={<GetDetailEmail />} />
                <Route path="/getDetailEmail/comment/:eventId" element={<GetDetailEmail />} />
                <Route path="/getDetailEmail/postevent/:eventId" element={<GetDetailEmail />} />
                <Route path="/getDetail/:eventId" element={<GetDetail />} />
                <Route path="/getDetail/guest/:eventId" element={<GetDetail />} />
                <Route path="/getDetail/comment/:eventId" element={<GetDetail />} />
                <Route path="/getDetail/postevent/:eventId" element={<GetDetail />} />
                <Route path="/GetDetailAdmin/:eventId" element={<GetDetailAdmin />} />
                <Route path="/GetDetailAdmin/guest/:eventId" element={<GetDetailAdmin />} />
                <Route path="/GetDetailAdmin/comment/:eventId" element={<GetDetailAdmin />} />
                <Route path="/GetDetailAdmin/postevent/:eventId" element={<GetDetailAdmin />} />
                <Route path="/GetDetailMarsComplete/:eventId" element={<GetDetailMarsComplete />} />
                <Route path="/GetDetailMarsComplete/guest/:eventId" element={<GetDetailMarsComplete />} />
                <Route path="/GetDetailMarsComplete/comment/:eventId" element={<GetDetailMarsComplete />} />
                <Route path="/GetDetailMarsComplete/postevent/:eventId" element={<GetDetailMarsComplete />} />
                <Route path="/getDetailEventMlt/:eventId" element={<GetDetailEventMlt />} />
                <Route path="/getDetailEventMlt/guest/:eventId" element={<GetDetailEventMlt />} />
                <Route path="/getDetailEventMlt/comment/:eventId" element={<GetDetailEventMlt />} />
                <Route path="/getDetailEventMlt/postevent/:eventId" element={<GetDetailEventMlt />} />
                <Route path="/AppAdmin" element={<AppAdmin />} />
                <Route path="/AppRequester" element={<RequesterApp />} />
                <Route path="/AppFamily" element={<MarsFamilyCompleteApp />} />
                <Route path="/AppMltEvent" element={<EventMltComplete />} />
                <Route path="/AppReport" element={<AppReport />} />
                <Route path="/eventReport" element={<EventsReport />} />
                <Route path="/touchesReport" element={<TouchesReport />} />
                <Route path="/siteReport" element={<SiteReport />} />
                <Route path="/anniversaryReport" element={<AnniversaryContainer />} />
                <Route path="/user-management" element={<UserManagement />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/user" element={<AddUser />} />
                <Route path="/site-management" element={<SiteManagement />} />
                <Route path="/siteDetails" element={<SiteDetails />} />
                <Route path="/emailTemplate" element={<EmailConditionsList />} />
                <Route path="/notification-page" element={<NotificationListPage />} />
                <Route path="/emailDetails/:emailId" element={<EmailDetails />} />
                <Route path="/emailNewTemplate" element={<EmailNewTemplate />} />
                <Route path="/AppSettings" element={<AppSettings />} />
              </Route>
            </Routes>
            <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/js/bootstrap.bundle.min.js" integrity="sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz" crossOrigin="anonymous"></script>
          </div>
        </Router>
        <ToastContainer />
        {isLoading &&
          (<div className="d-flex justify-content-center w-100 h-100 position-fixed top-0 left-0 loading-fade">
            <div className="spinner-border mt-auto mb-auto" role="status">
            </div>
          </div>)
        }
      </MsalProvider>
    </MantineProvider>
  );
}

export default App;
